export default __webpack_public_path__ + "static/media/ic-plus-blue-24-px.9ec6a619.svg";